import Bento from '@/src/Common/components/Bento';
import GalleryStats from './GalleryStats';
import ShareStats from './ShareStats';
import DeviceStats from './DeviceStats';
import { useParams } from 'react-router-dom';
import EventDashboardFrame from './EventDashboardFrame';

export default function EventDashboard() {
    const { activationId } = useParams();

    return (
        <EventDashboardFrame
            navLocation="dashboard"
            activationId={activationId || ''}
        >
            <Bento
                blockOne={<GalleryStats activationId={Number(activationId)} />}
                blockTwo={<ShareStats activationId={Number(activationId)} />}
                blockThree={<DeviceStats activationId={Number(activationId)} />}
            />
        </EventDashboardFrame>
    );
}
